import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";

import Router from "./router";
import i18n from "./translation";
import { AuthProvider } from "./context/AuthContext";

const App = () => (
  <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <I18nextProvider i18n={i18n}>
          <Router />
        </I18nextProvider>
      </BrowserRouter>
    </AuthProvider>
  </HelmetProvider>
);

const container = document.getElementById("root") as HTMLElement;

// scripts/prerender.js snapshots public routes into real static HTML at
// build time so crawlers see actual content instead of an empty #root
// (see that script for the full explanation) — but every page here
// starts in a loading state and fetches its real content async, so its
// very first client render never matches the snapshot's DOM. Attempting
// hydrateRoot() against that mismatch just produces React error #418/
// #423 and falls back to a full re-render anyway (React's built-in
// recovery), so there's nothing to gain from trying: always mount fresh.
// The prerendered HTML still does its job for crawlers regardless, since
// they read it before any of this JS runs.
createRoot(container).render(<App />);
